import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {DobryAgentBlogArticle} from '../../../../shared/interface/dobry-agent-blog-article';
import {DobryAgentBlogService} from '../../../../shared/services/dobry-agent-blog.service';

@Component({
  selector: 'app-da-article-details',
  templateUrl: './da-article-details.component.html',
  styleUrls: ['./da-article-details.component.scss']
})
export class DaArticleDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  articleId?: string;
  loading = false;
  modify = false;

  blogArticleObject?: DobryAgentBlogArticle;
  blogArticle: ReplaySubject<DobryAgentBlogArticle> = new ReplaySubject<DobryAgentBlogArticle>(1);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private blogService: DobryAgentBlogService,
  ) {
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.articleId = params.id;
        this.load();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  load(): void {
    if (!this.articleId) {
      this.router.navigate(['/blog-dobry-agent/artykuly']);
      return;
    }

    this.loading = true;

    this.blogService.get(this.articleId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (article: DobryAgentBlogArticle) => {
          this.blogArticleObject = article;
          this.blogArticle.next(article);
          this.loading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;

          this.snack.open('Nie udało się pobrać danych artykułu', error.status.toString(), {
            duration: 2000
          });

          this.router.navigate(['/blog-dobry-agent/artykuly']);
        }
      });
  }

  onModificationClosed(): void {
    this.modify = false;
    this.load();
  }
}
